import React, { useState, useEffect, useMemo, useRef, createRef } from 'react';
import styles from 'wienenergiedesignsystem/components/Accordion/components/AccordionGroup/AccordionGroup.module.scss';
export var AccordionContext = /*#__PURE__*/React.createContext();

var AccordionGroup = function AccordionGroup(_ref) {
  var children = _ref.children,
      allowMultiple = _ref.allowMultiple,
      defaultOpenIndex = _ref.defaultOpenIndex,
      expanded = _ref.expanded;

  var _useState = useState(defaultOpenIndex),
      selectedIndex = _useState[0],
      setSelectedIndex = _useState[1];

  var childrenRefs = useRef([]);

  if (childrenRefs.current.length !== children.length) {
    childrenRefs.current = Array(children.length).fill().map(function (_, i) {
      return childrenRefs.current[i] || /*#__PURE__*/createRef();
    });
  }

  useEffect(function () {
    setSelectedIndex(defaultOpenIndex);
  }, [defaultOpenIndex]);
  var accordionState = useMemo(function () {
    return {
      allowMultiple: allowMultiple,
      selectedIndex: selectedIndex,
      setSelectedIndex: setSelectedIndex
    };
  }, [allowMultiple, selectedIndex]);
  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: accordionState
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.accordionGroup
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      index: index,
      isOpen: index === defaultOpenIndex || expanded,
      ref: childrenRefs.current[index]
    });
  })));
};

export default AccordionGroup;